export default __webpack_public_path__ + "static/media/pic1.e4509ea0.jpg";